import React from "react";

const NoInternet = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M18 27.34c1.01 0 1.939.35 2.669.935L18 31.555l-2.668-3.28A4.242 4.242 0 0118 27.34zM4.999 4l25.006 24.845-2 1.987-5.21-5.172-.349.43a7.073 7.073 0 00-4.444-1.561 7.073 7.073 0 00-4.444 1.56l-2.666-3.28a11.307 11.307 0 016.538-2.483l-2.508-2.49a14.133 14.133 0 00-5.808 2.786l-2.67-3.28a18.398 18.398 0 015.073-2.89l-2.166-2.15a21.242 21.242 0 00-4.682 2.854L2 11.876a25.504 25.504 0 014.176-2.73L2.996 5.99 4.998 4zm18.78 14.724l-5.472-5.434-.305-.005c4.378 0 8.398 1.52 11.557 4.058l-2.668 3.28a14.162 14.162 0 00-3.112-1.9v.001zM18.001 6.258A25.452 25.452 0 0134 11.876l-2.665 3.279A21.217 21.217 0 0018 10.475c-.81 0-1.607.045-2.391.132l-3.66-3.63A25.7 25.7 0 0118 6.258z"
          fill={fill}
      />
    </svg>
);

export default NoInternet;
